import { BoxProps, Text } from '@chakra-ui/react'
import { ContentNode, DataTypeConfigUtils } from '@helo/cms'
import { If, pipe } from '@helo/utils'

import { Pill } from '../../components/Pill/Pill'
import { Skeleton } from '../../components/SkeletonLoader'
import { TypeRenderer } from '../../datatypes/TypeRenderer'
import { DataDriveWidgetProps } from '../widget-types'
import { createWidget } from '../widget-utils'

export type PillWidgetPropsBak = DataDriveWidgetProps

export type PillWidgetProps = BoxProps & {
  contentNode: ContentNode
  isLoading: boolean
}

export const PillWidget = ({
  contentNode,
  isLoading,
  ...props
}: PillWidgetProps) => {
  if (isLoading) {
    return <Skeleton w="100px" h="20px" />
  }

  if (!contentNode) return null
  if (Array.isArray(contentNode) && contentNode.length === 0) return null

  const contentNodeWithStyles =
    contentNode &&
    pipe(
      contentNode,
      If.then(
        contentNode => contentNode.kind === 'FIELD',
        DataTypeConfigUtils.getOfType(),
      ),
      DataTypeConfigUtils.updateState({
        styles: { fontSize: '12px', fontWeight: '600' },
      }),
    )

  return (
    <Pill size="sm" {...props}>
      <Text
        color="presets.neutral.80"
        fontSize="12px"
        fontWeight="500"
        mr="8px"
      >
        {contentNode.state?.label}
      </Text>

      <TypeRenderer contentNode={contentNodeWithStyles} />
    </Pill>
  )
}

export const PillWidgetDefinition = createWidget(PillWidget, {
  type: 'Pill',
  slots: [],
  isDataDriven: true,
})
